import { ORDER_APIS } from "@/api_framework/api_config";
import { IOderManagementActionBody, IOrderManagementActionItemsResponse } from "@/api_framework/api_modals/Orders";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});
// returns new created userId
export const useOrderCancelOnPartner = () => {
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();
  const execute = useCallback(async (suborderId: IOderManagementActionBody): Promise<string | null> => {
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key) as string;
      const requestHeaders = new Headers();
      requestHeaders.append("Authorization", `${accessToken}`);
      await axios
        .post(
          `${ORDER_APIS?.ORDER_CANCEL_ON_PARTNER?.baseURL}`,
          { sub_order_id: suborderId },
          {
            headers: { Authorization: requestHeaders.get("Authorization") },
          },
        )
        .then((res: AxiosResponse<IOrderManagementActionItemsResponse>) => {
          if (res.data.status === true) {
            toast.success("Order data updated successfully");
          } else {
            toast.error("Order data updated faild");
          }
        })
        .catch((e: AxiosError) => {
          sendCurl(e.config["curlCommand"]);
          captureError(e);
          return null;
        });
    } catch (e: any) {
      toast.error("Server Error: " + e.message);
      return null;
    }
    return null;
  }, []);
  return execute;
};
